import {
  RECEIVE_CURRENT_USER_DETAILS,
  REQUEST_CURRENT_USER_DETAILS_FAILURE,
} from '../constants/actionTypes';

export const initialState = {
  id: null,
  firstName: '',
  lastName: '',
  countryCode: '',
  email: '',
  preferredUnits: '',
  error: null,
};

function currentUserReducer(state = initialState, action = {}) {
  switch (
    action.type // NOSONAR
  ) {
    case RECEIVE_CURRENT_USER_DETAILS: {
      const { id, firstName, lastName, email, countryCode, preferences } =
        action.userDetails;

      return {
        ...state,
        id,
        firstName,
        lastName,
        email,
        countryCode,
        preferredUnits: preferences.unitsOfMeasureTemplateName,
      };
    }

    case REQUEST_CURRENT_USER_DETAILS_FAILURE: {
      const { error } = action;

      return {
        ...state,
        error,
      };
    }

    default:
      return state;
  }
}

export default currentUserReducer;
